import { type QueryHookOptions, useQuery } from "@apollo/client";
import { RevenueShareReportsListQuery } from "../graphql/queries";
import type {
  RevenueShareReportsListQueryType,
  RevenueShareReportsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useRevenueShareReportsQuery = (
  options?: QueryHookOptions<
    RevenueShareReportsListQueryType,
    RevenueShareReportsListQueryVariablesType
  >
) => {
  return useQuery<
    RevenueShareReportsListQueryType,
    RevenueShareReportsListQueryVariablesType
  >(RevenueShareReportsListQuery, options);
};
